/**
 * Set the initial states for XB Fee Calculator
 */
export function prepareXBInitialState(recipientDetails, store) {
  const {
    availableCurrencies,
    isCrossBorderRecipient,
    recipientCurrencies,
    recipientCurrencyCode,
    recipientCurrencyMap,
    rate,
    senderCountryCode,
    recipientCountryName,
    senderLocalCurrency,
    isUnilateral,
    token,
  } = recipientDetails

  let { recipientCountryCode } = recipientDetails

  if (isUnilateral && !recipientCountryCode && token) {
    recipientCountryCode = senderCountryCode
  }

  const currencyMap = store.amount.currencyMap
  const currencyList = Object.keys(currencyMap).map(currency => {
    return { code: currency, symbol: currencyMap[currency] }
  })
  const fromCurrencyCodeList =
    availableCurrencies || currencyList.map(x => x.code)

  return {
    availableCurrencies,
    fromCurrencyCode: senderLocalCurrency,
    fromCountryCode: senderCountryCode,
    fromCurrencyCodeList,
    showXBCalculator: !!isCrossBorderRecipient,
    toCurrencyCode: recipientCurrencyCode,
    toCountryCode: recipientCountryCode,
    toCountryName: recipientCountryName,
    toCurrencyCodeList: recipientCurrencies,
    rate,
    toCurrencySymbolMap: recipientCurrencyMap,
  }
}
